import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import hp from './httpPath'
import VueResource from 'vue-resource'
import VueNativeSock from 'vue-native-websocket'
import AsyncComputed from 'vue-async-computed'
import * as VueGoogleMaps from "vue2-google-maps";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'



// AsyncComputed
Vue.use(AsyncComputed);
// Moment
/*Vue.use(require('vue-moment'));*/
Vue.use(VueMoment, {
  moment,
});
// Подгрузка гугл мапы
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBHyuQ62n301zpKTXqY7CrSPm1zLqYzW7Y",
    libraries: "places"
  }
});


// Get Cookie
export function GET_COOKIE(name){
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}


// HTTP запросы
let pathHttp = hp.data().path;
export const imgPath = pathHttp.HTTP_COMM;
if( process.env.NODE_ENV === 'dev' ) pathHttp = hp.data().pathDev

export const HTTP = axios.create({
  baseURL : pathHttp.HTTP
});
export const HTTP_AUTH = axios.create({
  baseURL : pathHttp.HTTP_AUTH
});
// Общий HTTP COMM запрос
export const HTTP_COMM = axios.create({
  baseURL : pathHttp.HTTP_COMM
});
// vue-resource
Vue.use(VueResource);

// Socket
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from './store/mutation-types'

const mutations = {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
};

Vue.use( VueNativeSock, pathHttp.socket, {
    store: store,
    format: 'json',
    mutations: mutations,
    reconnection: false,
    reconnectionDelay: 3000,
    connectManually : true
  });


// Select
import VueSelect from 'vue-cool-select'
Vue.use(VueSelect, {
  theme: 'bootstrap' // or 'material-design'
});

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// Scrollbar
import PerfectScrollbar from 'vue2-perfect-scrollbar'

import router from './router'
Vue.use(PerfectScrollbar);




import VueYandexMetrika from 'vue-yandex-metrika';
Vue.use(VueYandexMetrika, {
  id: 95301979,
  router: router,
  env: process.env.NODE_ENV,
  options : {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true,
    trackHash:true
  }
});

// Start App
Vue.config.productionTip = false;



new Vue({
  store,
  axios,
  router,
  render: h => h(App)
}).$mount('#app');
